export const hvCharts = [
  {
    title: 'Percentage of Children with Incomplete Vaccination Schedule',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'UptoDate=No',
    main_link_for_chart: '/vaccine-history?UptoDate=No',
    filters: [
      {
        total_text: 'Total registered',
        total: 'AgeInYears=0',
        value: 'UptoDate=No',
        link: '/vaccine-history?UptoDate=No&AgeInYears=0',
        label: '0',
        custom_property_name_2: 'Age',
        custom_property_value_2: '0',
        filtered_total_text: 'Missing Immunisations',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=1',
        value: 'UptoDate=No',
        link: '/vaccine-history?UptoDate=No&AgeInYears=1',
        label: '1',
        custom_property_name_2: 'Age',
        custom_property_value_2: '1',
        filtered_total_text: 'Missing Immunisations',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=2',
        value: 'UptoDate=No',
        link: '/vaccine-history?UptoDate=No&AgeInYears=2',
        label: '2',
        custom_property_name_2: 'Age',
        custom_property_value_2: '2',
        filtered_total_text: 'Missing Immunisations',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=3',
        value: 'UptoDate=No',
        link: '/vaccine-history?UptoDate=No&AgeInYears=3',
        label: '3',
        custom_property_name_2: 'Age',
        custom_property_value_2: '3',
        filtered_total_text: 'Missing Immunisations',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=4',
        value: 'UptoDate=No',
        link: '/vaccine-history?UptoDate=No&AgeInYears=4',
        label: '4',
        custom_property_name_2: 'Age',
        custom_property_value_2: '4',
        filtered_total_text: 'Missing Immunisations',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=5',
        value: 'UptoDate=No',
        link: '/vaccine-history?UptoDate=No&AgeInYears=5',
        label: '5',
        custom_property_name_2: 'Age',
        custom_property_value_2: '5',
        filtered_total_text: 'Missing Immunisations',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=6',
        value: 'UptoDate=No',
        link: '/vaccine-history?UptoDate=No&AgeInYears=6',
        label: '6',
        custom_property_name_2: 'Age',
        custom_property_value_2: '6',
        filtered_total_text: 'Missing Immunisations',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with No Vaccinations Recorded',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'UptoDate=No record',
    main_link_for_chart: '/vaccine-history?UptoDate=No record',
    filters: [
      {
        total_text: 'Total registered',
        total: 'AgeInYears=0',
        value: 'UptoDate=No record',
        link: '/vaccine-history?UptoDate=No record&AgeInYears=0',
        label: '0',
        custom_property_name_2: 'Age',
        custom_property_value_2: '0',
        filtered_total_text: 'No Immunisation Record',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=1',
        value: 'UptoDate=No record',
        link: '/vaccine-history?UptoDate=No record&AgeInYears=1',
        label: '1',
        custom_property_name_2: 'Age',
        custom_property_value_2: '1',
        filtered_total_text: 'No Immunisation Record',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=2',
        value: 'UptoDate=No record',
        link: '/vaccine-history?UptoDate=No record&AgeInYears=2',
        label: '2',
        custom_property_name_2: 'Age',
        custom_property_value_2: '2',
        filtered_total_text: 'No Immunisation Record',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=3',
        value: 'UptoDate=No record',
        link: '/vaccine-history?UptoDate=No record&AgeInYears=3',
        label: '3',
        custom_property_name_2: 'Age',
        custom_property_value_2: '3',
        filtered_total_text: 'No Immunisation Record',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=4',
        value: 'UptoDate=No record',
        link: '/vaccine-history?UptoDate=No record&AgeInYears=4',
        label: '4',
        custom_property_name_2: 'Age',
        custom_property_value_2: '4',
        filtered_total_text: 'No Immunisation Record',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=5',
        value: 'UptoDate=No record',
        link: '/vaccine-history?UptoDate=No record&AgeInYears=5',
        label: '5',
        custom_property_name_2: 'Age',
        custom_property_value_2: '5',
        filtered_total_text: 'No Immunisation Record',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=6',
        value: 'UptoDate=No record',
        link: '/vaccine-history?UptoDate=No record&AgeInYears=6',
        label: '6',
        custom_property_name_2: 'Age',
        custom_property_value_2: '6',
        filtered_total_text: 'No Immunisation Record',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with Complete Vaccination Schedule',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'UptoDate=Yes',
    main_link_for_chart: '/vaccine-history?UptoDate=Yes',
    filters: [
      {
        total_text: 'Total registered',
        total: 'AgeInYears=0',
        value: 'UptoDate=Yes',
        link: '/vaccine-history?UptoDate=Yes&AgeInYears=0',
        label: '0',
        custom_property_name_2: 'Age',
        custom_property_value_2: '0',
        filtered_total_text: 'Up to Date',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=1',
        value: 'UptoDate=Yes',
        link: '/vaccine-history?UptoDate=Yes&AgeInYears=1',
        label: '1',
        custom_property_name_2: 'Age',
        custom_property_value_2: '1',
        filtered_total_text: 'Up to Date',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=2',
        value: 'UptoDate=Yes',
        link: '/vaccine-history?UptoDate=Yes&AgeInYears=2',
        label: '2',
        custom_property_name_2: 'Age',
        custom_property_value_2: '2',
        filtered_total_text: 'Up to Date',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=3',
        value: 'UptoDate=Yes',
        link: '/vaccine-history?UptoDate=Yes&AgeInYears=3',
        label: '3',
        custom_property_name_2: 'Age',
        custom_property_value_2: '3',
        filtered_total_text: 'Up to Date',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=4',
        value: 'UptoDate=Yes',
        link: '/vaccine-history?UptoDate=Yes&AgeInYears=4',
        label: '4',
        custom_property_name_2: 'Age',
        custom_property_value_2: '4',
        filtered_total_text: 'Up to Date',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=5',
        value: 'UptoDate=Yes',
        link: '/vaccine-history?UptoDate=Yes&AgeInYears=5',
        label: '5',
        custom_property_name_2: 'Age',
        custom_property_value_2: '5',
        filtered_total_text: 'Up to Date',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=6',
        value: 'UptoDate=Yes',
        link: '/vaccine-history?UptoDate=Yes&AgeInYears=6',
        label: '6',
        custom_property_name_2: 'Age',
        custom_property_value_2: '6',
        filtered_total_text: 'Up to Date',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with Refusals',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'HasRefusals=true',
    main_link_for_chart: '/vaccine-history?HasRefusals=true',
    filters: [
      {
        total_text: 'Total registered',
        total: 'AgeInYears=0',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&AgeInYears=0',
        label: '0',
        custom_property_name_2: 'Age',
        custom_property_value_2: '0',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=1',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&AgeInYears=1',
        label: '1',
        custom_property_name_2: 'Age',
        custom_property_value_2: '1',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=2',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&AgeInYears=2',
        label: '2',
        custom_property_name_2: 'Age',
        custom_property_value_2: '2',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=3',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&AgeInYears=3',
        label: '3',
        custom_property_name_2: 'Age',
        custom_property_value_2: '3',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=4',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&AgeInYears=4',
        label: '4',
        custom_property_name_2: 'Age',
        custom_property_value_2: '4',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=5',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&AgeInYears=5',
        label: '5',
        custom_property_name_2: 'Age',
        custom_property_value_2: '5',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=6',
        value: 'HasRefusals=true',
        link: '/vaccine-history?HasRefusals=true&AgeInYears=6',
        label: '6',
        custom_property_name_2: 'Age',
        custom_property_value_2: '6',
        filtered_total_text: 'Children with Refusals',
        filtered_total_value: '',
      },
    ],
  },
  {
    title: 'Percentage of Children with Suspensions',
    ref: 'dynamicArrayV4',
    summary_search_parameter_for_charts: 'HasSuspensions=true',
    main_link_for_chart: '/vaccine-history?HasSuspensions=true',
    filters: [
      {
        total_text: 'Total registered',
        total: 'AgeInYears=0',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&AgeInYears=0',
        label: '0',
        custom_property_name_2: 'Age',
        custom_property_value_2: '0',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=1',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasHasSuspensions=true&AgeInYears=1',
        label: '1',
        custom_property_name_2: 'Age',
        custom_property_value_2: '1',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=2',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&AgeInYears=2',
        label: '2',
        custom_property_name_2: 'Age',
        custom_property_value_2: '2',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=3',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&AgeInYears=3',
        label: '3',
        custom_property_name_2: 'Age',
        custom_property_value_2: '3',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=4',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasHasSuspensions=true&AgeInYears=4',
        label: '4',
        custom_property_name_2: 'Age',
        custom_property_value_2: '4',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=5',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&AgeInYears=5',
        label: '5',
        custom_property_name_2: 'Age',
        custom_property_value_2: '5',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
      {
        total_text: 'Total registered',
        total: 'AgeInYears=6',
        value: 'HasSuspensions=true',
        link: '/vaccine-history?HasSuspensions=true&AgeInYears=6',
        label: '6',
        custom_property_name_2: 'Age',
        custom_property_value_2: '6',
        filtered_total_text: 'Children with Suspensions',
        filtered_total_value: '',
      },
    ],
  },
];
